module.exports = __webpack_public_path__ + "img/commodore-george-dewey.1cf62c38.png";